
export interface QueueStatusMatrix {
  [status: string]: {
    Intake: boolean
    Deficiency: boolean
    Analyst: boolean
    DNQ: boolean
    Admin: boolean
    BG: boolean
    DashboardAdmin: boolean
  }
}

// export const QUEUE_STATUS_MATRIX: QueueStatusMatrix = {
//   'IN PROGRESS, NOT SUBMITTED':     { Intake: false, Deficiency: false, Analyst: false, DNQ: false, Admin: true, BG: false },
//   'BACKOFFICE PENDING':            { Intake: false, Deficiency: false, Analyst: false, DNQ: false, Admin: true, BG: false },
//   'APPROVED':                      { Intake: false, Deficiency: false, Analyst: false, DNQ: false, Admin: true, BG: false },
//   'INTAKE':                        { Intake: true,  Deficiency: false, Analyst: false, DNQ: false, Admin: true, BG: false },
//   'DEFICIENCY':                    { Intake: false, Deficiency: false, Analyst: false, DNQ: false, Admin: true, BG: false },
//   'ANALYST':                       { Intake: false, Deficiency: false, Analyst: true,  DNQ: false, Admin: true, BG: false },
//   'ANALYST DENIED':                { Intake: false, Deficiency: false, Analyst: false, DNQ: true,  Admin: true, BG: false },
//   'INTAKE PENDING + BG PENDING':   { Intake: true,  Deficiency: false, Analyst: false, DNQ: false, Admin: true, BG: true  },
//   'INTAKE PENDING + BG APPROVED':  { Intake: true,  Deficiency: false, Analyst: false, DNQ: false, Admin: true, BG: true  },
//   'INTAKE PENDING + BG DENIED':    { Intake: true,  Deficiency: false, Analyst: false, DNQ: false, Admin: true, BG: true  },
//   'DEFICIENCY PENDING + BG PENDING':{ Intake: false, Deficiency: true, Analyst: false, DNQ: false, Admin: true, BG: true  },
//   'DEFICIENCY PENDING + BG APPROVED':{ Intake: false, Deficiency: true, Analyst: false, DNQ: false, Admin: true, BG: true  },
//   'DEFICIENCY + BG DENIED':        { Intake: false, Deficiency: false, Analyst: false, DNQ: false, Admin: true, BG: true  },
//   'ANALYST PENDING + BG PENDING':  { Intake: false, Deficiency: false, Analyst: true,  DNQ: false, Admin: true, BG: true  },
//   'ANALYST PENDING + BG APPROVED': { Intake: false, Deficiency: false, Analyst: true,  DNQ: false, Admin: true, BG: true  },
//   'ANALYST PENDING + BG DENIED':   { Intake: false, Deficiency: false, Analyst: true,  DNQ: false, Admin: true, BG: true  },
//   'ANALYST DENIED + BG PENDING':   { Intake: false, Deficiency: false, Analyst: false, DNQ: true,  Admin: true, BG: true  },
//   'ANALYST DENIED + BG APPROVED':  { Intake: false, Deficiency: false, Analyst: false, DNQ: true,  Admin: true, BG: true  },
//   'ANALYST DENIED + BG DENIED':    { Intake: false, Deficiency: false, Analyst: false, DNQ: true,  Admin: true, BG: true  },
//   'PARTIALLY APPROVED + BG PENDING':{ Intake: false, Deficiency: false, Analyst: false, DNQ: true,  Admin: true, BG: true  },
//   'PARTIALLY APPROVED + BG APPROVED':{ Intake: false, Deficiency: false, Analyst: false, DNQ: true,  Admin: true, BG: true  },
//   'PARTIALLY APPROVED + BG DENIED':{ Intake: false, Deficiency: false, Analyst: false, DNQ: true,  Admin: true, BG: true  },
//   'ANALYST APPROVED + BG PENDING': { Intake: false, Deficiency: false, Analyst: false, DNQ: true,  Admin: true, BG: true  }
// };

// All status keys where each property is true
export const intake = [
  { appStatus: '17', bgStatus: ['Pending'], applicationStatus:'Backoffice Pending' },               
  { appStatus: '17', bgStatus: ['Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission'] ,applicationStatus: 'Backoffice Pending'}, // Backoffice Pending
  { appStatus: '18', bgStatus: ['Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission','Pending'] , applicationStatus: 'Intake Pending + BG Pending'}, // Intake
  { appStatus: '18', bgStatus: ['Clear'] , applicationStatus: 'Intake Pending + BG Approved'}, // Intake
  { appStatus: '18', bgStatus: [] , applicationStatus: 'Intake Pending'}, // Intake
 
];

export const deficiency = [
  { appStatus: '19', bgStatus: ['Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission','Pending'], applicationStatus:'Deficiency Pending + BG Pending' } , // Deficiency --- only for sprint2 workaround
  { appStatus: '19', bgStatus: ['Clear'], applicationStatus:'Deficiency Pending + BG Approved' },  // Deficiency --- only for sprint2 workaround
  { appStatus: '19', bgStatus: [], applicationStatus:'Deficiency Pending' }  // Deficiency --- only for sprint2 workaround
];

export const analyst = [
  { appStatus: '17', bgStatus: [] ,applicationStatus:'Backoffice Pending'},
  { appStatus: '20', bgStatus: [] ,applicationStatus:'Analyst Pending'},         // Analyst
  { appStatus: '20', bgStatus: [
      'Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission','Pending'
    ] , applicationStatus:'Analyst Pending + BG Pending'},// Analyst Pending + BG Pending
  { appStatus: '20', bgStatus: ['Clear'], applicationStatus:'Analyst Pending + BG Approved' },  // Analyst Pending + BG Approved
];

export const doesNotQualify = [
  { appStatus: '21', bgStatus: [] ,applicationStatus:'Analyst Denied'},         // Analyst Denied
  { appStatus: '21', bgStatus: [
      'Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission','Pending'
    ], applicationStatus:'Analyst Denied + BG Pending'},// Analyst Denied + BG Pending
  { appStatus: '21', bgStatus: ['Clear'], applicationStatus:'Analyst Denied + BG Approved' },  // Analyst Denied + BG Approved
  // { appStatus: '32', bgStatus: ['Denied'], applicationStatus:'' }, // Analyst Denied + BG Denied
  { appStatus: '40', bgStatus: [
      'Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission','Pending'
    ], applicationStatus:'Partially Approved + BG Pending' },// Partially Approved + BG Pending
  { appStatus: '40', bgStatus: ['Clear'], applicationStatus:'Partially Approved + BG Approved' },  // Partially Approved + BG Approved
  // { appStatus: '36', bgStatus: ['Denied'], applicationStatus:'' }, // Partially Approved + BG Denied
  // { appStatus: '37', bgStatus: [
  //     'Card Over 1 Year',
  //     'Information Requested',
  //     'In process',
  //     'Issued',
  //     'Manual',
  //     'Record Found',
  //     'Reprint',
  //     'Resubmission'
  //   ], applicationStatus:'' } // Analyst Approved + BG Pending
  { appStatus: '40', bgStatus: [], applicationStatus:'Partially Approved' } // Partially Approved
];

export const admin = [
  { appStatus: '17', bgStatus: [] ,applicationStatus:'Backoffice Pending'},
  { appStatus: '17', bgStatus: ['Pending'], applicationStatus:'Backoffice Pending' },               
  { appStatus: '17', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission'], applicationStatus:'Backoffice Pending' },              
  { appStatus: '18', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Intake Pending + BG Pending' },               
  { appStatus: '18', bgStatus: ['Clear'], applicationStatus:'Intake Pending + BG Approved' },     
  { appStatus: '18', bgStatus: ['Denied'], applicationStatus:'Intake Pending + BG Denied' },     
  { appStatus: '19', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Deficiency Pending + BG Pending' },              
  { appStatus: '19', bgStatus: ['Clear'], applicationStatus:'Deficiency Pending + BG Approved' },               
  { appStatus: '19', bgStatus: ['Denied'], applicationStatus:'Deficiency Pending + BG Denied' },     
  { appStatus: '20', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Analyst  Pending + BG Pending' },        
  { appStatus: '20', bgStatus: ['Clear'], applicationStatus:'Analyst Pending + BG Approved' },       
  { appStatus: '20', bgStatus: ['Denied'], applicationStatus:'Analyst Pending + BG Denied' },     
  { appStatus: '21', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Analyst Denied + BG Pending' },       
  { appStatus: '21', bgStatus: ['Clear'], applicationStatus:'Analyst Denied + BG Approved' }, 
  { appStatus: '21', bgStatus: ['Denied'], applicationStatus:'Analyst Denied + BG Denied' },       
  { appStatus: '40', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Partially Approved + BG Pending' },       
  { appStatus: '40', bgStatus: ['Clear'], applicationStatus:'Partially Approved + BG Approved' },      
  { appStatus: '40', bgStatus: ['Denied'], applicationStatus:'Partially Approved + BG Denied' },      
  { appStatus: '9', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Analyst Approved + BG Pending' },       
  { appStatus: '9', bgStatus: ['Clear'], applicationStatus:'Analyst Approved + BG Approved' },      
  { appStatus: '9', bgStatus: ['Denied'], applicationStatus:'Analyst Approved + BG Denied' },      
  { appStatus: '18', bgStatus: [], applicationStatus:'Intake Pending' },      
  { appStatus: '19', bgStatus: [], applicationStatus:'Deficiency Pending' },
  { appStatus: '20', bgStatus: [], applicationStatus:'Analyst Pending' },  
  { appStatus: '21', bgStatus: [], applicationStatus:'Analyst Denied' },
  { appStatus: '40', bgStatus: [], applicationStatus:'Partially Approved' },
  { appStatus: '9', bgStatus: [], applicationStatus:'Analyst Approved' },
  { appStatus: '41', bgStatus: [], applicationStatus:'Approved' } , 
    { appStatus: '44', bgStatus: [], applicationStatus:'Reversed' },
];

export const DashboardAdmin = [
    { appStatus: '43', bgStatus: [], applicationStatus:'Extended' },
  { appStatus: '44', bgStatus: [], applicationStatus:'Reversed' },
  { appStatus: '16', bgStatus: [], applicationStatus:'In Progress, Not Submitted' }, 
  { appStatus: '17', bgStatus: [] ,applicationStatus:'Backoffice Pending'},              
  { appStatus: '17', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Backoffice Pending' },              
  { appStatus: '18', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Intake Pending + BG Pending' },               
  { appStatus: '18', bgStatus: ['Clear'], applicationStatus:'Intake Pending + BG Approved' },     
  { appStatus: '18', bgStatus: ['Denied'], applicationStatus:'Intake Pending + BG Denied' },     
  { appStatus: '19', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Deficiency Pending + BG Pending' },              
  { appStatus: '19', bgStatus: ['Clear'], applicationStatus:'Deficiency Pending + BG Approved' },               
  { appStatus: '19', bgStatus: ['Denied'], applicationStatus:'Deficiency Pending + BG Denied' },     
  { appStatus: '20', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Analyst  Pending + BG Pending' },        
  { appStatus: '20', bgStatus: ['Clear'], applicationStatus:'Analyst Pending + BG Approved' },       
  { appStatus: '20', bgStatus: ['Denied'], applicationStatus:'Analyst Pending + BG Denied' },     
  { appStatus: '21', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Analyst Denied + BG Pending' },       
  { appStatus: '21', bgStatus: ['Clear'], applicationStatus:'Analyst Denied + BG Approved' }, 
  { appStatus: '21', bgStatus: ['Denied'], applicationStatus:'Analyst Denied + BG Denied' },       
  { appStatus: '40', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Partially Approved + BG Pending' },       
  { appStatus: '40', bgStatus: ['Clear'], applicationStatus:'Partially Approved + BG Approved' },      
  { appStatus: '40', bgStatus: ['Denied'], applicationStatus:'Partially Approved + BG Denied' },      
  { appStatus: '9', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending'], applicationStatus:'Analyst Approved + BG Pending' },       
  { appStatus: '9', bgStatus: ['Clear'], applicationStatus:'Analyst Approved + BG Approved' },      
  { appStatus: '9', bgStatus: ['Denied'], applicationStatus:'Analyst Approved + BG Denied' },      
  { appStatus: '18', bgStatus: [], applicationStatus:'Intake Pending' },      
  { appStatus: '19', bgStatus: [], applicationStatus:'Deficiency Pending' },
  { appStatus: '20', bgStatus: [], applicationStatus:'Analyst Pending' },  
  { appStatus: '21', bgStatus: [], applicationStatus:'Analyst Denied' },
  { appStatus: '40', bgStatus: [], applicationStatus:'Partially Approved' },
  { appStatus: '9', bgStatus: [], applicationStatus:'Analyst Approved' },
  { appStatus: '41', bgStatus: [], applicationStatus:'Approved' }  
];


export const background = [
  { appStatus: '17', bgStatus: ['Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission','Pending'], applicationStatus:'Backoffice Pending' },    // Backoffice Pending
  { appStatus: '18', bgStatus: ['Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission','Pending','Clear','Denied'
    ], applicationStatus:'Intake Pending' }, // Intake Pending + BG Pending
  { appStatus: '19', bgStatus: ['Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission','Pending','Clear','Denied'
    ], applicationStatus:'Deficiency Pending' }, // Deficiency Pending + BG Pending
  { appStatus: '20', bgStatus: ['Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission','Pending','Clear','Denied'
    ], applicationStatus:'Analyst Pending' }, // Analyst Pending + BG Pending
  { appStatus: '21', bgStatus: ['Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission','Pending','Clear','Denied'
    ], applicationStatus:'Analyst Denied' }, // Analyst Denied + BG Pending
  { appStatus: '9', bgStatus: ['Card Over 1 Year',
      'Information Requested',
      'In process',
      'Issued',
      'Manual',
      'Record Found',
      'Reprint',
      'Resubmission','Pending','Clear','Denied'], applicationStatus:'Analyst Approved' }, //Analyst Approved + BG Pending
  { appStatus: '40', bgStatus: ['Card Over 1 Year','Information Requested','In process',
    'Issued','Manual','Record Found','Reprint','Resubmission','Pending','Clear','Denied'], applicationStatus:'Partially Approved' } // Partially Approved    
];

